import { request, requestPublic } from "./request.js";

// 发布首页-手机端
export function PublishHomeMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishHomeMobile",
    method: "post",
    data: data,
  });
}

// 发布普通专升本-手机端
export function PublishPtzsbHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishPtzsbHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布自考专升本-手机端
export function PublishZkzsbHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishZkzsbHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布成考专升本-手机端
export function PublishCkzsbHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishCkzsbHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布开放教育-手机端
export function PublishWlycjyHtmlMobile(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishWlycjyHtmlMobile",
    method: "post",
    data: data,
  });
}

// 发布首页--PC端
export function PublishHome(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishHome",
    method: "post",
    data: data,
  });
}

// 发布普通专升本--PC端
export function CreatePtzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreatePtzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布自考专升本--PC端
export function CreateZkzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateZkzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布成考专升本--PC端
export function CreateCkzsbCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateCkzsbCategoryHtml",
    method: "post",
    data: data,
  });
}

// 发布开放教育--PC端
export function CreateWlycjyCategoryHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/CreateWlycjyCategoryHtml",
    method: "post",
    data: data,
  });
}

// 批量发布
export function PublishHtml(data) {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/PublishHtml",
    method: "post",
    data:data
  });
}

// 查看对应的类别
export function GetPublishCategory() {
  return request({
    url: "/api2/ZsbSiteAdmin/HtmlRelease/GetPublishCategory",
    method: "get",
  });
}